import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { X, ChevronRight, ArrowRight } from "lucide-react";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const TodayPlanner = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const todayIso = iso(new Date());

  useEffect(() => {
    api.get("/mealplan")
      .then((r) => setItems((r.data.items || []).filter((i) => i.day === todayIso)))
      .catch(() => setItems([]));
  }, [todayIso]);

  const remove = async (item_id) => {
    await api.delete(`/mealplan/item/${item_id}`);
    setItems((it) => it.filter((x) => x.item_id !== item_id));
  };

  if (items === null) return null;

  return (
    <div data-testid="today-planner-widget" className="mb-10 animate-fade-up">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-display text-4xl font-extrabold tracking-tight">Today</h2>
        <Link to="/planner" data-testid="open-planner-link"
          className="inline-flex items-center gap-1 text-lg font-semibold text-nerd-light/80 hover:text-nerd-light transition-colors">
          Planner <ChevronRight className="w-5 h-5" />
        </Link>
      </div>

      {items.length === 0 ? (
        <button data-testid="browse-next-meal-btn" onClick={() => navigate("/browse")}
          className="w-full flex items-center justify-between gap-4 rounded-3xl bg-nerd-card border border-dashed border-black/10 p-5 text-left hover:bg-black/5 transition-colors">
          <span className="text-sm text-nerd-light/60">Nothing planned for today yet.</span>
          <span className="shrink-0 inline-flex items-center gap-2 text-sm font-semibold text-nerd-light">Browse your next meal <ArrowRight className="w-4 h-4" /></span>
        </button>
      ) : (
        <div className="space-y-3">
          {items.map((it) => (
            <div key={it.item_id} data-testid={`today-plan-item-${it.recipe_id}`}
              className="flex items-center gap-4 rounded-3xl bg-nerd-card p-3 pr-4">
              <img src={it.thumbnail} alt={it.title} onClick={() => navigate(`/recipe/${it.recipe_id}`)}
                className="w-20 h-20 rounded-2xl object-cover cursor-pointer shrink-0" />
              <h3 onClick={() => navigate(`/recipe/${it.recipe_id}`)}
                className="flex-1 font-display text-xl sm:text-2xl font-extrabold tracking-tight leading-tight line-clamp-2 cursor-pointer">{it.title}</h3>
              <button data-testid={`today-remove-${it.item_id}`} onClick={() => remove(it.item_id)}
                className="shrink-0 w-12 h-12 rounded-full bg-white text-black flex items-center justify-center hover:opacity-90 transition-opacity">
                <X className="w-5 h-5" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
